import classnames from 'classnames';

import { PopupBuilderNewsletterContentSection } from '../contentTypes';
import { NewsletterForm } from '../form/NewsletterForm';
import { Div } from '../HTMLElement';
import { buildVisibilityClassNamesFromContent } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderNewsletterComponentProps extends PopupBuilderNewsletterContentSection {}

const PopupBuilderNewsletterComponent = ({ options }: PopupBuilderNewsletterComponentProps) => {
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  return (
    <Div
      className={classnames('popup-builder-newsletter-component', options?.classes)}
      uiClassName={{ bs5: visibilityClassNames }}
    >
      <NewsletterForm source="website-modal" />
    </Div>
  );
};

export type PopupBuilderNewsletterComponentVariants = '';

const PopupBuilderNewsletterComponentController = (
  props: PropsWithCustomComponent<PopupBuilderNewsletterComponentProps>
) => (
  <VariantsController<PopupBuilderNewsletterComponentProps, PopupBuilderNewsletterComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderNewsletterComponent,
      name: 'PopupBuilderNewsletterComponent',
    }}
  />
);
export { PopupBuilderNewsletterComponentController as PopupBuilderNewsletterComponent };
